import * as React from "react";
import { connect } from 'react-redux';
import { hidePhotoStepsScreen, hideFullscreenCamera } from "../../actions/fullscreenActions";
import ReactCamera from "./ReactCamera";
import { photoData } from "../../actions/cameraActions";
import { IMAGE_PREVIEW } from "../../routes/routes";
import {
    CHILLI_MONTHLY_PHOTO_STEP1_HEADER_SUBMITTED, CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION_SUBMITTED,
    CHILLI_MONTHLY_PHOTO_STEP2_HEADER, CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION_UPLOADED, CHILLI_MONTHLY_RIGHT_CHECKMARK
} from "../../constants/copy";
import { navigateTo } from "../../actions/navigationActions";
import { logEvent } from "../../firebase/firebase";

class FullscreenCamera extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.handlePhotoCallback = this.handlePhotoCallback.bind(this);
    }

    async handlePhotoCallback(photo) {
        var lat = 0;
        var lon = 0;
        navigator.geolocation.getCurrentPosition(async (position) => {
            lat = position.coords.latitude;
            lon = position.coords.longitude
        })
        if (this.props.profile.selfInspectionStep === 1) {
            logEvent('SSP_Chilli_Dashboard_Photo_Taken', {});
            await this.props.dispatchPhotoData({
                dashboardPhotoData: photo,
                dashboardHeader: CHILLI_MONTHLY_PHOTO_STEP1_HEADER_SUBMITTED,
                dashboardDescription: CHILLI_MONTHLY_PHOTO_STEP1_DESCRIPTION_SUBMITTED,
                step1RightImageUrl: CHILLI_MONTHLY_RIGHT_CHECKMARK,
                step1Backround: "#fff",
                step2Backround: "#e6e6e6",
                dashboardCanSubmit: true,
                photoData: photo,
                photoAccepted: false,
                photoSubmitted: true,
                dashboardLat: lat,
                dashboardLon: lon,
            });
        }
        if (this.props.profile.selfInspectionStep === 2) {
            logEvent('SSP_Chilli_Odometer_Photo_Taken', {});
            await this.props.dispatchPhotoData({
                mileagePhotoData: photo,
                mileageHeader: CHILLI_MONTHLY_PHOTO_STEP2_HEADER,
                mileageDescription: CHILLI_MONTHLY_PHOTO_STEP2_DESCRIPTION_UPLOADED,
                step2RightImageUrl: CHILLI_MONTHLY_RIGHT_CHECKMARK,
                step2Backround: "#fff",
                step3Backround: "#e6e6e6",
                mileageCanSubmit: true,
                photoData: photo,
                photoAccepted: false,
                photoSubmitted: true,
                mileageLat: lat,
                mileageLon: lon,
            });
        }
        if (typeof this.props.profile.selfInspectionStep === 'string') {
            logEvent('SSP_SELF_INSPECTION_' + this.props.profile.selfInspectionStep.toUpperCase() + '_PHOTO_TAKEN', {});
            await this.props.dispatchPhotoData({
                selfInspectPhotoData: photo,
                photoData: photo,
                photoAccepted: false,
                photoSubmitted: true,
                selfInspectLat: lat,
                selfInspectLon: lon,
            });
        }
        if (this.props.claimSubmit.selectedDamagePhotoTypes) {
            await this.props.dispatchPhotoData({
                selfInspectPhotoData: photo,
                photoAccepted: false,
                photoSubmitted: true,
                dashboardLat: lat,
                dashboardLon: lon,
            });
        }
        this.props.dispatchHideFullscreenCamera();
        this.props.dispatchRedirectToImagePreview();
    }

    render() {
        let camera = <div></div>;

        if (this.props.fullscreen.fullscreenCameraVisible) {
            camera = <ReactCamera photoTakenCallback={this.handlePhotoCallback} />
        }

        return (
            <>
                <div className="webcam-background">
                    <div className="text-center">
                        <div className="container text-center">
                        </div>
                        {camera}
                    </div>
                </div>

            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        fullscreen: state.fullscreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchPhotoData: (data) => dispatch(photoData(data)),
        dispatchHidePhotoStepsScreen: () => dispatch(hidePhotoStepsScreen()),
        dispatchHideFullscreenCamera: () => dispatch(hideFullscreenCamera()),
        dispatchRedirectToImagePreview: () => dispatch(navigateTo(IMAGE_PREVIEW)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FullscreenCamera)